'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   Switch,
   useOutsideClick,
   useBreakpointValue,
   Modal,
   useToast,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   SimpleGrid,
   ModalFooter,
   useColorMode,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import DaybookForm from './DaybookForm';
import { useDispatch, useSelector } from 'react-redux';
import {
   downloadPDF,
   downloadExcel,
   useServerPagination,
   useFilterData,
   usePagination,
} from '../../../../../utils/DataTableUtils';
import { renderFormControl } from '../../../../../utils/DynamicFormData';
import {
   getDaybook,
   getDaybookForMaster,
   deleteDaybook,
   getSingleDaybook,
   updateDaybookIsOld,
   multiDeleteDaybook,
} from '../../../../../redux/actions/daybook';
import DeleteDialog from '../../components/DeleteDialog';
import ViewSingleData from '../../components/ViewSingleData';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import DynamicTable from '../../components/DynamicAllDataTable';
import MobileDataTable from '../../components/MobileDataTable';
import { postColumnsHideShow } from '../../../../../redux/actions/utility';
import { BsEye } from 'react-icons/bs';
import { useGlobal } from '../../../../../contexts';
import { userProfile } from '../../../../../redux/actions/user';

// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { useUser } from 'contexts';
import Loader from 'views/admin/default/Loader';
import { X } from 'lucide-react';

//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

// Default column visibility
const defaultColumnVisibility = {
   name: true,
   typeName: true,
   subTypeName: false,
   accountNo: false,
   account_name: true,
   termsNConditions: false,
   autoRoundOffAtName: false,
   methodOfRoundLIName: false,
   issuedaybookname: false,
   isOld: false,
   status: true,
};

// Helper function to get column visibility from localStorage
const getStoredColumnVisibility = (companyId) => {
   try {
      const stored = localStorage.getItem(`daybook-column-visibility-${companyId}`);
      if (stored) {
         const parsed = JSON.parse(stored);
         // Merge with defaults to ensure all columns are present
         return { ...defaultColumnVisibility, ...parsed };
      }
   } catch (error) {
      console.error('Error loading column visibility from localStorage:', error);
   }
   return defaultColumnVisibility;
};

// Helper function to save column visibility to localStorage
const saveColumnVisibilityToStorage = (companyId, visibility) => {
   try {
      localStorage.setItem(`daybook-column-visibility-${companyId}`, JSON.stringify(visibility));
   } catch (error) {
      console.error('Error saving column visibility to localStorage:', error);
   }
};

export default function DaybookMaster({ columnsData }) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const daybookData = useSelector((state) => state.daybook?.listForMaster || []);
   const totalCount = useSelector((state) => state.daybook.totalCountForMaster);
   const pagination = useSelector((state) => state.daybook?.paginationForMaster);
   const [data, setData] = React.useState([...daybookData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const isAbs = currentRow?.isAbs === 'true' || currentRow?.isAbs === true;
   const [searchQuery, setSearchQuery] = React.useState('');
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const singleEntity = useSelector((state) => state?.daybook?.single || {});
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [isLoading, setIsLoading] = useState(false);
   const companyId = Number(localStorage.getItem('companyId'));
   const { user } = useUser();
   const Admin = user?.isAdmin;

   // Initialize column visibility from localStorage first, then from user settings
   const [columnVisibility, setColumnVisibility] = React.useState(() => {
      // First try to get from localStorage
      const storedVisibility = getStoredColumnVisibility(companyId);
      return storedVisibility;
   });

   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const isDesktop = useBreakpointValue({ base: false, md: true });

   const daybookRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.daybook
      : null;

   // Use the server pagination hook
   const {
      // handlePageSizeChange,
      // handlePageChange,
      resetPage,
      // totalPages,
      // currentPage,
      // pageSize,
      // getPaginationParams,
   } = useServerPagination(totalCount);

   const filteredData = useFilterData(data, searchQuery, columnsData); // Filtered data
   const {
      // paginatedData,
      // handlePageSizeChange,
      // handlePageChange,
      totalPages,
      pageSize,
      // currentPage,
      getPaginationParams,
   } = usePagination(data, filteredData); // Pagination

   // Load column visibility from user settings when user data is available
   useEffect(() => {
      if (!user?.viewJson) return;

      const companySettings = user.viewJson.find((item) => item.companyId === companyId);

      if (companySettings?.daybook) {
         // Merge user settings with current visibility (preserving localStorage values)
         setColumnVisibility((prev) => ({ ...prev, ...companySettings.daybook }));
      }
   }, [user, companyId]);

   // Save column visibility to localStorage whenever it changes
   useEffect(() => {
      saveColumnVisibilityToStorage(companyId, columnVisibility);
   }, [columnVisibility, companyId]);

   const { userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.daybook;
   const shouldShowCompanyDropdown = globalSetting || false;

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n' || e.key === '+') {
            if (!isOpen && !isOpenSingleView && (Admin || daybookRight?.add)) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, Admin, daybookRight?.add]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   // Handle search input changes
   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   useEffect(() => {
      if (user && user?.loginhistory?.companyId) {
         const fetchMainData = async () => {
            try {
               setIsLoading(true);
               await dispatch(
                  getDaybookForMaster({
                     page: currentPage,
                     // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
                     search: debouncedSearchQuery,
                     companyId: user?.loginhistory?.companyId,
                     sortBy: sorting.length ? sorting[0]?.name : 'name',
                     sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                     ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
            } catch (error) {
               console.error('Error fetching main data:', error);
            } finally {
               setIsLoading(false);
            }
         };

         fetchMainData();
      }
   }, [dispatch, currentPage, limit, debouncedSearchQuery, sorting, companyId]);

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         // Direct page number navigation
         setCurrentPage(directionOrPage);
      } else {
         // Previous/next navigation
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;

      // If "ALL" is selected, set limit to null or totalProducts to fetch everything
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);

      setLimit(newLimit);
      setCurrentPage(1); // Reset to page 1 to avoid offset issues
   };
   const paginatedData = React.useMemo(() => {
      if (limit === pagination?.totalProducts) return daybookData;

      if (!Array.isArray(daybookData) || daybookData.length === 0) {
         return [];
      }
      // const startIndex = (pagination?.currentPage - 1) * limit;
      // const endIndex = startIndex + limit;

      return daybookData;
   }, [daybookData, pagination?.currentPage, limit, pagination?.totalProducts]);

   // useEffect(() => {
   //   setData([...daybookData]);
   // }, [daybookData]);

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteDaybook(selectedRowId, companyId));
            await dispatch(
               getDaybookForMaster({
                  page: currentPage,
                  // limit: limit,
                  search: debouncedSearchQuery,
                  companyId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
            await dispatch(
               getDaybook({
                  page: currentPage,
                  // limit: limit,
                  search: debouncedSearchQuery,
                  companyId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
         } catch (err) {
            // console.error("Failed to delete Color:", err);
         }
      }
      setIsOpenSingleView(false);
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleMutiDeleteClick = async (ids) => {
      if (ids.length > 0) {
         const payload = {
            ids: ids.map(Number),
            compId: user?.loginhistory?.companyId.toString(),
         };
         dispatch(multiDeleteDaybook(JSON.stringify(payload)));
         setDeleteDialogOpen(false); // Close the dialog after deletion
         await dispatch(
            getDaybookForMaster({
               page: currentPage,
               // limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };

   const handleIsOld = useCallback(async (e, id) => {
      const { checked } = e.target;
      dispatch(updateDaybookIsOld({ id: id, isOld: checked })); // Update the isOld status in the database
      if (user && user?.loginhistory?.companyId)
         dispatch(
            getDaybookForMaster({
               page: currentPage,
               // limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
   }, []);

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      ?.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = (formData) => {
      if (isEditMode && currentRow) {
         setData(data?.map((row) => (row.id === currentRow.id ? { ...currentRow, ...formData } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...formData, id: Date.now() }]);
      }
      onClose();
      setIsOpenSingleView(true);
   };

   const handleClose = () => {
      onClose();
      setSearchQuery('');
   };

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const toast = useToast();
      const companyId = Number(localStorage.getItem('companyId'));

      useEffect(() => {
         if (isOpen) {
            setLocalVisibility(columnVisibility);
         }
      }, [isOpen, columnVisibility]);

      useEffect(() => {
         const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
               onClose();
            }
         };

         if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
         }

         return () => {
            document.removeEventListener('keydown', handleEscKey);
         };
      }, [isOpen, onClose]);

      const handleSave = async () => {
         try {
            const updatedViewJson = user.viewJson
               ? user.viewJson.map((item) =>
                  item.companyId === companyId ? { ...item, daybook: localVisibility } : item,
               )
               : [{ companyId, daybook: localVisibility }];

            await dispatch(
               postColumnsHideShow({
                  userId: user?.id,
                  viewJson: updatedViewJson,
               }),
            );

            // Update both state and localStorage
            setColumnVisibility(localVisibility);
            saveColumnVisibilityToStorage(companyId, localVisibility);

            toast({ title: 'Column settings saved successfully', status: 'success' });
            onClose();
         } catch (error) {
            toast({
               title: 'Failed to save column settings',
               status: 'error',
               description: error.message,
            });
         }
      };

      const handleBackdropClick = (e) => {
         // Only close if clicking directly on backdrop, not on modal content
         if (e.target === e.currentTarget) {
            onClose();
         }
      };

      // Don't render if modal is not open
      if (!isOpen) return null;

      return (
         <div className="fixed inset-0 z-[999] flex items-center justify-center p-4" onClick={handleBackdropClick}>
            <div
               className={`absolute inset-0 transition-colors duration-300 ${isDark ? 'bg-black/70' : 'bg-black/40'}`}
            />

            <div
               className={`relative w-full max-w-2xl transform transition-all duration-300 ${isDark
                  ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'
                  : 'bg-gradient-to-br from-white via-gray-50 to-white'
                  } rounded-2xl shadow-2xl border ${isDark ? 'border-slate-700/50' : 'border-gray-200/50'
                  } overflow-hidden flex flex-col max-h-[80vh]`}
               onClick={(e) => e.stopPropagation()}>
               {/* Header - Fixed */}
               <div
                  className={`relative px-8 py-6 border-b flex-shrink-0 ${isDark
                     ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                     : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                     }`}>
                  <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Show/Hide Columns</h2>
                  <p className={`mt-1 text-sm ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                     Customize which columns appear in your view
                  </p>
                  <button
                     onClick={onClose}
                     aria-label="Close modal"
                     className={`absolute top-6 right-6 p-2 rounded-lg transition-all duration-200 ${isDark
                        ? 'hover:bg-slate-700/50 text-slate-400 hover:text-white'
                        : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                        }`}>
                     <X className="w-5 h-5" />
                  </button>
               </div>

               {/* Scrollable Content */}
               <div className="flex-1 overflow-y-auto px-8 py-6">
                  <div className="grid grid-cols-2 gap-4">
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <div
                           key={key}
                           className={`group relative p-3 rounded-xl transition-all duration-300 border-2 ${value
                              ? isDark
                                 ? 'bg-gradient-to-br from-blue-900/20 to-indigo-900/20 border-blue-500/50 shadow-lg shadow-blue-500/10'
                                 : 'bg-gradient-to-br from-blue-50/50 to-indigo-50/50 border-blue-400/50 shadow-lg shadow-blue-200/30'
                              : isDark
                                 ? 'bg-slate-800/30 border-slate-700/30 hover:border-slate-600/50'
                                 : 'bg-white/50 border-gray-300/30 hover:border-gray-400/50'
                              } cursor-pointer hover:scale-[1.02]`}
                           onClick={() => setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }))}>
                           <div className="flex items-center justify-between">
                              <label
                                 className={`font-semibold text-base cursor-pointer transition-colors duration-200 capitalize ${isDark ? 'text-white' : 'text-gray-900'
                                    }`}>
                                 {key
                                    .split(/(?=[A-Z])/)
                                    .join(' ')
                                    .toLowerCase()}
                              </label>

                              <div
                                 className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${value
                                    ? isDark
                                       ? 'bg-gradient-to-r from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30'
                                       : 'bg-gradient-to-r from-blue-500 to-indigo-500 shadow-lg shadow-blue-400/30'
                                    : isDark
                                       ? 'bg-slate-700'
                                       : 'bg-gray-300'
                                    }`}>
                                 <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md ${value ? 'translate-x-6' : 'translate-x-1'
                                       }`}
                                 />
                              </div>
                           </div>

                           <div
                              className={`mt-3 flex items-center gap-2 text-xs font-medium ${value
                                 ? isDark
                                    ? 'text-blue-400'
                                    : 'text-blue-600'
                                 : isDark
                                    ? 'text-slate-500'
                                    : 'text-gray-500'
                                 }`}>
                              <div
                                 className={`h-1.5 w-1.5 rounded-full ${value
                                    ? isDark
                                       ? 'bg-blue-400 shadow-lg shadow-blue-400/50'
                                       : 'bg-blue-500 shadow-lg shadow-blue-400/50'
                                    : isDark
                                       ? 'bg-slate-600'
                                       : 'bg-gray-400'
                                    }`}
                              />
                              {value ? 'Visible' : 'Hidden'}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>

               {/* Footer - Fixed */}
               <div
                  className={`px-8 py-5 border-t flex justify-end gap-3 flex-shrink-0 ${isDark
                     ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                     : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                     }`}>
                  <button
                     onClick={onClose}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${isDark
                        ? 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
                        : 'text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                        }`}>
                     Cancel
                  </button>
                  <button
                     onClick={handleSave}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg ${isDark
                        ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white shadow-blue-500/30'
                        : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-blue-400/30'
                        }`}>
                     Save
                  </button>
               </div>
            </div>
         </div>
      );
   };

   // --------------------- filter --------------------- //
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');

   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [NameselectedFilter, setNameselectedFilter] = useState(''); // Stores input value
   const [TYPEselectedFilter, setTYPEselectedFilter] = useState('');
   const [SUBTYPEselectedFilter, setSUBTYPEselectedFilter] = useState('');
   const [ACCOUNTNOselectedFilter, setACCOUNTNOselectedFilter] = useState('');
   const [ACCOUNTNAMEselectedFilter, setACCOUNTNAMEselectedFilter] = useState('');
   const [TERMSCONDITIONSselectedFilter, setTERMSCONDITIONSselectedFilter] = useState('');
   const [AUTOROUNDOFFATselectedFilter, setAUTOROUNDOFFATselectedFilter] = useState('');
   const [METHODOFROUNDLIselectedFilter, setMETHODOFROUNDLIselectedFilter] = useState('');
   const [ISSUEDAYBOOKNAMEselectedFilter, setISSUEDAYBOOKNAMEselectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [NameInputValue, setNameInputValue] = useState(''); // Stores input value
   const [TYPEInputValue, setTYPEInputValue] = useState('');
   const [SUBTYPEInputValue, setSUBTYPEInputValue] = useState('');
   const [ACCOUNTNOInputValue, setACCOUNTNOInputValue] = useState('');
   const [ACCOUNTNAMEInputValue, setACCOUNTNAMEInputValue] = useState('');
   const [TERMSCONDITIONSInputValue, setTERMSCONDITIONSInputValue] = useState('');
   const [AUTOROUNDOFFATInputValue, setAUTOROUNDOFFATInputValue] = useState('');
   const [METHODOFROUNDLIInputValue, setMETHODOFROUNDLIInputValue] = useState('');
   const [ISSUEDAYBOOKNAMEInputValue, setISSUEDAYBOOKNAMEInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [DaybookData, setDaybookData] = useState([]);

   useEffect(() => {
      if (user && user?.loginhistory?.companyId) {
         const fetchData = async () => {
            try {
               // const fetchParams = selectedFilter === "option11" ? { type: 'K', name: NameInputValue } : { type: 'K' };

               let fetchParams = {
                  companyId: user?.loginhistory?.companyId,
                  page: currentPage,
                  // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               };
               let filters = [];

               if (NameInputValue && NameselectedFilter) {
                  filters.push({ name: 'dba.name', value: NameInputValue, type: NameselectedFilter });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (TYPEInputValue && TYPEselectedFilter) {
                  filters.push({ name: 'dba.type', value: TYPEInputValue, type: TYPEselectedFilter });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (SUBTYPEInputValue && SUBTYPEselectedFilter) {
                  filters.push({ name: 'dba."subType"', value: SUBTYPEInputValue, type: SUBTYPEselectedFilter });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (ACCOUNTNOInputValue && ACCOUNTNOselectedFilter) {
                  filters.push({ name: 'dba."accountNo"', value: ACCOUNTNOInputValue, type: ACCOUNTNOselectedFilter });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (ACCOUNTNAMEInputValue && ACCOUNTNAMEselectedFilter) {
                  filters.push({ name: 'ac.name', value: ACCOUNTNAMEInputValue, type: ACCOUNTNAMEselectedFilter });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (TERMSCONDITIONSInputValue && TERMSCONDITIONSselectedFilter) {
                  filters.push({
                     name: 'dba."termsNConditions"',
                     value: TERMSCONDITIONSInputValue,
                     type: TERMSCONDITIONSselectedFilter,
                  });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (AUTOROUNDOFFATInputValue && AUTOROUNDOFFATselectedFilter) {
                  filters.push({
                     name: 'dba."autoRoundOffAt"',
                     value: AUTOROUNDOFFATInputValue,
                     type: AUTOROUNDOFFATselectedFilter,
                  });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (METHODOFROUNDLIInputValue && METHODOFROUNDLIselectedFilter) {
                  filters.push({
                     name: 'dba."methodOfRoundLI"',
                     value: METHODOFROUNDLIInputValue,
                     type: METHODOFROUNDLIselectedFilter,
                  });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               if (ISSUEDAYBOOKNAMEInputValue && ISSUEDAYBOOKNAMEselectedFilter) {
                  filters.push({
                     name: 'dba2.name',
                     value: ISSUEDAYBOOKNAMEInputValue,
                     type: ISSUEDAYBOOKNAMEselectedFilter,
                  });
                  fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
               }
               const response = await dispatch(getDaybookForMaster(fetchParams));

               // Check if response is an array
               if (response.length > 0 && Array.isArray(response)) {
                  setDaybookData(response);
               } else {
                  console.warn('No data found. Setting empty array.');
                  // setNameInputValue("");
                  setDaybookData([]); // ✅ Prevents 'undefined' error
               }
            } catch (error) {
               console.error('Error fetching data:', error);
               setDaybookData([]); // ✅ Ensure an empty array is set
            }
         };
         fetchData();
      }
   }, [
      user,
      dispatch,
      NameInputValue,
      TYPEInputValue,
      SUBTYPEInputValue,
      ACCOUNTNOInputValue,
      ACCOUNTNAMEInputValue,
      TERMSCONDITIONSInputValue,
      AUTOROUNDOFFATInputValue,
      METHODOFROUNDLIInputValue,
      ISSUEDAYBOOKNAMEInputValue,
   ]);

   useEffect(() => {
      setData([...daybookData]);
   }, [daybookData]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setDropdownOpen(true);
      if (selectedColumn?.props?.children === 'Name') {
         setInputValue(NameInputValue);
      } else if (selectedColumn?.props?.children === 'TYPE') {
         setInputValue(TYPEInputValue);
      } else if (selectedColumn?.props?.children === 'SUB TYPE') {
         setInputValue(SUBTYPEInputValue);
      } else if (selectedColumn?.props?.children === 'ACCOUNT NO') {
         setInputValue(ACCOUNTNOInputValue);
      } else if (selectedColumn?.props?.children === 'ACCOUNT NAME') {
         setInputValue(ACCOUNTNAMEInputValue);
      } else if (selectedColumn?.props?.children === 'TERMS CONDITIONS') {
         setInputValue(TERMSCONDITIONSInputValue);
      } else if (selectedColumn?.props?.children === 'AUTO ROUND OFF AT') {
         setInputValue(AUTOROUNDOFFATInputValue);
      } else if (selectedColumn?.props?.children === 'METHOD OF ROUND LI') {
         setInputValue(METHODOFROUNDLIInputValue);
      } else if (selectedColumn?.props?.children === 'ISSUE DAYBOOK NAME') {
         setInputValue(ISSUEDAYBOOKNAMEInputValue);
      }
      // setIsModalOpen(true); // Open modal
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         NAME: setNameInputValue,
         TYPE: setTYPEInputValue,
         'SUB TYPE': setSUBTYPEInputValue,
         'ACCOUNT NO': setACCOUNTNOInputValue,
         'ACCOUNT NAME': setACCOUNTNAMEInputValue,
         'TERMS CONDITIONS': setTERMSCONDITIONSInputValue,
         'AUTO ROUND OFF AT': setAUTOROUNDOFFATInputValue,
         'METHOD OF ROUND LI': setMETHODOFROUNDLIInputValue,
         'ISSUE DAYBOOK NAME': setISSUEDAYBOOKNAMEInputValue,
      };

      const selectedoption = {
         NAME: setNameselectedFilter,
         TYPE: setTYPEselectedFilter,
         'SUB TYPE': setSUBTYPEselectedFilter,
         'ACCOUNT NO': setACCOUNTNOselectedFilter,
         'ACCOUNT NAME': setACCOUNTNAMEselectedFilter,
         'TERMS CONDITIONS': setTERMSCONDITIONSselectedFilter,
         'AUTO ROUND OFF AT': setAUTOROUNDOFFATselectedFilter,
         'METHOD OF ROUND LI': setMETHODOFROUNDLIselectedFilter,
         'ISSUE DAYBOOK NAME': setISSUEDAYBOOKNAMEselectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter); // Assign value only on button click
      }

      setDropdownOpen(false);
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'NAME') {
         setNameInputValue('');
      }
      if (selectedColumn?.props?.children === 'TYPE') {
         setTYPEInputValue('');
      }
      if (selectedColumn?.props?.children === 'SUB TYPE') {
         setSUBTYPEInputValue('');
      }
      if (selectedColumn?.props?.children === 'ACCOUNT NO') {
         setACCOUNTNOInputValue('');
      }
      if (selectedColumn?.props?.children === 'ACCOUNT NAME') {
         setACCOUNTNAMEInputValue('');
      }
      if (selectedColumn?.props?.children === 'TERMS CONDITIONS') {
         setTERMSCONDITIONSInputValue('');
      }
      if (selectedColumn?.props?.children === 'AUTO ROUND OFF AT') {
         setAUTOROUNDOFFATInputValue('');
      }
      if (selectedColumn?.props?.children === 'METHOD OF ROUND LI') {
         setMETHODOFROUNDLIInputValue('');
      }
      if (selectedColumn?.props?.children === 'ISSUE DAYBOOK NAME') {
         setISSUEDAYBOOKNAMEInputValue('');
      }
      setSelectedFilter('');
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
         case 'TYPE':
         case 'SUB TYPE':
            return '3%';
         case 'ACCOUNT NO':
         case 'ACCOUNT NAME':
         case 'TERMS CONDITIONS':
            return '30%';
         case 'AUTO ROUND OFF AT':
         case 'METHOD OF ROUND LI':
         case 'ISSUE DAYBOOK NAME':
            return '60%';
         default:
            return '70%';
      }
   };

   // const handleViewSingleData = async (id) => {
   //    await dispatch(getSingleDaybook(id));
   //    setIsOpenSingleView(true);
   // };
   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity?.name || '-' },
      { label: 'Type', value: singleEntity?.type || '-' },
      // { label: "Mobile", value: singleEntity?.mobile || "-" },
   ];

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   return (
      <>
         <Box bg={backgroundColor} w={'100%'}>
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb="8px"
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               {/* Left Section: Title + Add New Button */}
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Daybook
                  </Text>
               </Flex>

               {/* Right Section: Pagination + Limit + Search + Menu */}
               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || daybookRight?.add) && user && (!user.isExpired) && (
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}
                  <IconButton
                     colorScheme="gray"
                     icon={<BsEye />}
                     size="md"
                     mr={1}
                     onClick={() => setIsColumnModalOpen(true)}
                  />

                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           value={searchQuery}
                           color={icon}
                           // onChange={(e) => setSearchQuery(e.target.value)}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {/* Mobile Floating Add New Button */}
               {isMobileOrTablet && (Admin || daybookRight?.add) && user && (!user.isExpired) && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>

            {/* Table Rendering */}
            {isLoading ? (
               <Loader />
            ) : (
               <DynamicTable
                  right={daybookRight}
                  table={table}
                  data={paginatedData}
                  handleImageClick={handleImageClick}
                  toggleDropdown={toggleDropdown}
                  filter={filter}
                  emptyMessage="No daybook data found"
                  onEditClick={(row) => {
                     setCurrentRow(row);
                     setIsEditMode(true);
                     onOpen();
                     setIsOpenSingleView(false);
                  }}
                  onDeleteClick={(id) => {
                     handleDeleteClick(id);
                     setIsOpenSingleView(false);
                  }}
                  onMultiDeleteClick={(ids) => {
                     handleMutiDeleteClick(ids);
                  }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  columnsData={columnsData}
                  sorting={sorting}
                  limit={limit}
                  setCurrentRow={setCurrentRow}
                  onOpen={onOpen}
                  setIsEditMode={setIsEditMode}
                  setIsOpenSingleView={setIsOpenSingleView}
                  setDeleteDialogOpen={setDeleteDialogOpen}
                  setSelectedRowId={setSelectedRowId}
               // debouncedSearchQuery={debouncedSearchQuery}
               />
            )}
            <DaybookForm
               isOpen={isOpen}
               onClose={handleClose}
               isEditMode={isEditMode}
               currentRow={currentRow}
               onSave={handleSave}
               search={searchQuery}
               isAbs={isAbs}
            />

            <style jsx>{`
               .editable-row {
                  position: relative;
                  background: ${useColorModeValue('white', 'gray.700')};
                  transition: background 0.3s ease;
               }

               .editable-row:hover {
                  background: ${useColorModeValue('gray.100', 'gray.600')};
               }

               .editable-row .edit-icon-container {
                  display: none;
               }

               .editable-row:hover .edit-icon-container {
                  display: block;
                  position: absolute;
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
               }
            `}</style>
            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleDelete}
               title="daybook"
            />
            {/* <ViewSingleData
               isOpenSingleView={isOpenSingleView}
               onClose={() => setIsOpenSingleView(false)}
               entityType="daybook"
               singleEntity={singleEntity}
               dynamicArray={dynamicArray}
               formType="daybook"
            /> */}
         </Box>
         {isDropdownOpen && selectedColumn?.props?.children && (
            <Box
               position="absolute"
               top="350px" // Dropdown below image
               left={getLeftValue(selectedColumn?.props?.children)}
               width="auto"
               bg={backgroundColor}
               border="1px solid gray"
               borderRadius="5px"
               boxShadow="md"
               p="2"
               mt="2"
               zIndex="10"
               transition="all 0.2s ease-in-out">
               <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                  <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                     <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                  </Grid>
                  <hr></hr>
                  {/* Label and Dropdown */}
                  {['CREATED DATE', 'BALANCE', 'GST PERCENTAGE', 'HSN', 'ORDINAL', 'ACCOUNT NO'].includes(
                     selectedColumn?.props?.children,
                  ) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setcreateddateselectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="equal">Equal (=)</option>
                           <option value="less_than">Less than (&lt;)</option>
                           <option value="less_than_equal">Less than or equal (&le;)</option>
                           <option value="greater_than">Greater than (&gt;)</option>
                           <option value="greater_than_equal">Greater than or equal (&le;)</option>
                        </Select>
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="1">Starts With</option>
                           <option value="2">Ends With</option>
                           <option value="3">Contains</option>
                           <option value="4">Equal</option>
                           <option value="5">Empty</option>
                           <option value="6">Does Not Start With</option>
                           <option value="7">Does Not End With</option>
                           <option value="8">Does Not Contain</option>
                           <option value="9">Not Equal</option>
                           <option value="10">Not Empty</option>
                           <option value="11">Like</option>
                        </Select>
                     </GridItem>
                  )}

                  {/* Second Label and Input Box */}
                  <GridItem display="flex" alignItems="center">
                     <FormLabel htmlFor="input1" width="60%" color={textColor}>
                        Enter the value
                     </FormLabel>
                     <Input
                        id="input2"
                        color={textColor}
                        placeholder="Enter last name"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                     />
                  </GridItem>

                  {/* Button */}
                  <GridItem mt="20px" display="flex" justifyContent="space-between">
                     <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                        Filter
                     </Button>
                     <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                        cancel
                     </Button>
                  </GridItem>
               </Grid>
            </Box>
         )}

         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />
      </>
   );
}
